export default __webpack_public_path__ + "static/media/Puntos-interes2.7fe714ef.svg";